const TracingServiceSymbol = /* @__PURE__ */ Symbol("TracingService");
export {
  TracingServiceSymbol
};
//# sourceMappingURL=ITracingService.js.map
